import wrapInObserver from '../wrapInObserver';
import Icons from './Icons';

import {
  makePassportRatingUrl,
  makePassportAutoparkUrl,
  makeTopRatingFaqUrl,
  makeAtiDocsFaqUrl,
  makePassportRatingVerificationsUrl, makePassportContactsUrl, makeEtrnLandingUrl,
} from '../../utils/urlProvider';

const mapProps = ({ row }) => {
  const { iconsCollection, firm } = row;
  const {
    stars,
    trafficLight,
    reputationSignal,
    countryRating,
    cityRating,
    realTrucker,
    orders,
    atiDocs,
    confirmedContacts,
    epdBadgeIcon,
  } = iconsCollection;

  const starsUrl = makePassportRatingUrl(firm.atiId);
  const ordersUrl = makePassportRatingUrl(firm.atiId);
  const realTruckerUrl = makePassportAutoparkUrl(firm.atiId);
  const trafficLightUrl = makePassportRatingVerificationsUrl(firm.atiId);
  const topRatingUrl = makeTopRatingFaqUrl();
  const atiDocsUrl = makeAtiDocsFaqUrl();
  const reputationUrl = makePassportRatingVerificationsUrl(firm.atiId);
  const confirmedContactsUrl = makePassportContactsUrl(firm.atiId);
  const epdBadgeIconUrl = makeEtrnLandingUrl();

  return {
    stars,
    trafficLight,
    reputationSignal,
    countryRating,
    cityRating,
    realTrucker,
    orders,
    atiDocs,
    confirmedContacts,
    epdBadgeIcon,
    starsUrl,
    reputationUrl,
    realTruckerUrl,
    trafficLightUrl,
    topRatingUrl,
    atiDocsUrl,
    ordersUrl,
    confirmedContactsUrl,
    epdBadgeIconUrl,
  };
};

export default wrapInObserver(Icons, mapProps);
